import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { withApp } from 'helpers'
import { Page, Animation, PageTitle, PageContent, PageFooter, Heading, Text, Button, ButtonsGroup, Image } from 'components/library'
import { Container, Row, Col } from 'react-grid-system'
import { translate } from 'translations'
import endTestimg from './assets/Certificate.svg'

class EndtestPassedView extends React.Component {
  componentDidMount() {
    const nav = this.props.navigation.find(item => item.type === 'endtest')
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  render() {
    return (
      <Page>
        <Animation name="slideInDown" delay={100}>
          <PageTitle>
            <Heading h1>{translate('endtest.passedTitle')}</Heading>
            <Heading em>{translate('endtest.passedDescription')}</Heading>
          </PageTitle>
        </Animation>

        <Animation delay={200}>
          <PageContent>
            <Container>
              <Row align="center">
                <Col sm={7}>
                  <Heading h1>Gefeliciteerd!</Heading>
                  <Text>Je hebt deze e-Learning over het uitvoeren van sleepbewegingen succesvol afgerond. Overleg met je instructeur wanneer je klaar bent voor de theorieprofcheck. Voor meer informatie over de theorie- en praktijkprofcheck kun je terecht bij je instructeur of leidinggevende. Voor eventuele andere vragen kun je ook terecht bij het VTC via vtc@schiphol.nl.</Text>
                </Col>
                <Col sm={5}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'  }}>
                    <Image style={{ width: '25rem'  }} src={endTestimg} aspectRatio={100} />
                  </div>
                </Col>
              </Row>
            </Container>
          </PageContent>
        </Animation>

        <Animation delay={300}>
          <PageFooter>
            <div className="Page-footer-left">
              <Button outline to={Routes.to('home')} icon="home" />
            </div>

            <div className="Page-footer-right">
              <div></div>
              <ButtonsGroup>
                <Button primary outline square to={Routes.to('endtestTest')} label={translate('endtest.btnResults')} />
                <Button primary square to={Routes.to('home')} label={translate('endtest.btnExit')} />
              </ButtonsGroup>
            </div>
          </PageFooter>
        </Animation>
      </Page>
    )
  }
}

export default withApp(connect(
  (state, props) => ({
    navigation: state.content.navigation,
  }),
  (dispatch) => ({})
)(EndtestPassedView))



// WEBPACK FOOTER //
// ./src/components/views/endtest/EndtestPassedView.js